export const generateSummarySheet = (ws1, ws2, ws3, ws4) => {
  // Define styles
  const boldStyle = { font: { bold: true, name: 'Arial' } };
  const boldCenteredStyle = { 
    font: { bold: true, name: 'Arial' },
    alignment: { horizontal: 'center', vertical: 'middle' },
  };

  // Define column mappings for each worksheet
  const columnMappings = {
    'TOP Maturé': {
      volume: 'F',
      volumeEffectif: 'J',
      volumeAP: 'L'
    },
    'Stabulation vieux': {
      volume: 'G',
      volumeEffectif: 'K',
      volumeAP: 'L'
    },
    'TOP Pharma': {
      volume: 'F',
      volumeEffectif: 'K',
      volumeAP: 'J'
    }
  };

  // Set column widths
  ws4.columns = [
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 }
  ];

  // Add header
  ws4.mergeCells('C1:F1');
  ws4.getCell('C1').value = 'RÉSUMÉ DU SITE';
  ws4.getCell('C1').style = boldCenteredStyle;

  ws4.mergeCells('C2:F2');
  ws4.getCell('C2').value = 'Inventaire au : ' + new Date().toLocaleDateString('fr-FR');
  ws4.getCell('C2').style = boldCenteredStyle;

  // Add column headers
  const headers = [
    'Section',
    'Volume total',
    'Volume effectif total (à 20°C)',
    'Volume AP total'
  ];

  headers.forEach((header, index) => {
    const cell = ws4.getCell(4, index + 1);
    cell.value = header;
    cell.style = boldStyle;
  });

  // Helper function to find all total rows and create a sum formula
  const createTotalFormula = (ws, column, sheetName) => {
    const totalRows = [];
    
    // Find all rows with "TOTAL" in column A
    ws.eachRow((row, rowNumber) => {
      const cell = row.getCell(1);
      if (cell && cell.value === 'Total') {
        totalRows.push(rowNumber);
      }
    });

    if (totalRows.length === 0) {
      return `'${sheetName}'!${column}${ws.rowCount}`; // Fallback to last row
    }

    // Create a SUM formula for all total rows
    const cellRefs = totalRows.map(row => `'${sheetName}'!${column}${row}`);
    return `SUM(${cellRefs.join(',')})`;
  };

  // Add data rows with formulas
  const sections = [
    { name: 'TOP Maturé', ws: ws1 },
    { name: 'Stabulation vieux', ws: ws2 },
    { name: 'TOP Pharma', ws: ws3 }
  ];

  sections.forEach((section, index) => {
    const rowNumber = index + 5;
    const columns = columnMappings[section.name];
    
    // Section name
    const nameCell = ws4.getCell(rowNumber, 1);
    nameCell.value = section.name;
    nameCell.style = boldStyle;

    // Volume total
    const volumeCell = ws4.getCell(rowNumber, 2);
    volumeCell.value = { formula: createTotalFormula(section.ws, columns.volume, section.name) };
    volumeCell.style = boldStyle;

    // Volume effectif total
    const volumeEffectifCell = ws4.getCell(rowNumber, 3);
    volumeEffectifCell.value = { formula: createTotalFormula(section.ws, columns.volumeEffectif, section.name) };
    volumeEffectifCell.style = boldStyle;

    // Volume AP total
    const volumeAPCell = ws4.getCell(rowNumber, 4);
    volumeAPCell.value = { formula: createTotalFormula(section.ws, columns.volumeAP, section.name) };
    volumeAPCell.style = boldStyle;
  });

  // Add total row
  const totalRow = sections.length + 5;
  
  // Total label
  const totalLabelCell = ws4.getCell(totalRow, 1);
  totalLabelCell.value = 'TOTAL';
  totalLabelCell.style = boldStyle;

  // Total formulas
  const totalVolumeCell = ws4.getCell(totalRow, 2);
  totalVolumeCell.value = { formula: 'SUM(B5:B7)' };
  totalVolumeCell.style = boldStyle;

  const totalVolumeEffectifCell = ws4.getCell(totalRow, 3);
  totalVolumeEffectifCell.value = { formula: 'SUM(C5:C7)' };
  totalVolumeEffectifCell.style = boldStyle;

  const totalVolumeAPCell = ws4.getCell(totalRow, 4);
  totalVolumeAPCell.value = { formula: 'SUM(D5:D7)' };
  totalVolumeAPCell.style = boldStyle;

  // Set print settings
  ws4.pageSetup = {
    orientation: 'portrait',
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: {
      left: 0.25,
      right: 0.25,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3
    }
  };

  return ws4;
}; 